import React, { PropsWithChildren } from 'react';

import { useDisableBodyScroll } from 'hooks/useDisableBodyScroll';

import styles from './Modal.module.scss';

interface IModalOverlayProps {
  onClose: () => void;
}

const ModalOverlay = ({ onClose, children }: PropsWithChildren<IModalOverlayProps>) => {
  useDisableBodyScroll();

  return (
    <div className={styles.modalWrapper} onClick={onClose} role="button" tabIndex={0}>
      {children}
    </div>
  );
};

export default ModalOverlay;
